export class FXClick {

    constructor(options) {

        this.selector    = options.selector;

        this.cssClass    = options.class || 'active';
        this.delay       = options.delay || 500;
        this.atEnd       = options.atEnd || null;

        this.items = [...document.querySelectorAll(this.selector)];

        this.init();

    }

    init() {

        this.items?.forEach(item => {

            let ref = null;

            item.addEventListener("click", e => {

                item.classList.add(this.cssClass);

                clearTimeout(ref);

                if (this.atEnd === null) return;

                ref = setTimeout(() => {

                    if (this.atEnd === "removeClass") {

                        item.classList.remove(this.cssClass);

                    } else if (typeof this.atEnd === "function") {

                        this.atEnd(item);

                    }

                }, this.delay);

            });

        });
        
    }

}